import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  description: {
    fontFamily: 'Roboto !important',
    fontWeight: '400 !important',
    fontSize: '14px !important',
    color: '#000',
    letterSpacing: '0.15px !important',
    lineHeight: '143% !important',
  },
  containerTitle: {
    display: 'grid',
    gap: '6px',
  },
  containerForm: {
    width: '380px',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },
  buttonOutlined: {
    borderRadius: '20px !important',
    fontFamily: 'Roboto !important',
    fontSize: '14px !important',
    border: `1px solid ${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    width: '100%',
  },
  containerLink: {
    justifyContent: 'flex-end',
    display: 'flex',
  },
  divider: {
    margin: '10px 0px',
  },
  containerCreateUser: {
    display: 'grid',
    gap: '20px',
    marginTop: 20,
  },
  fakeStyle: {
    position: 'fixed',
    width: '0px',
    height: '0px',
    top: '-1000px',
    left: '-1000px',
    background: 'white',
    border: 'none',
  },
}));
